// extracted by mini-css-extract-plugin
export default {"dropdown":"InstrumentActionsButton_dropdown__jBdnj","icon":"InstrumentActionsButton_icon__DFUSc"};